import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { DoBootstrap, Injector, NgModule } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { MatProgressBar } from '@angular/material/progress-bar';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NasModelModule } from '@sama/ng-app-state';
import { ProgressBarComponent } from '../../cross-team-shared/components/progress-bar/progress-bar.component';
import { CrossTeamSharedModule } from '../../cross-team-shared/cross-team-shared.module';
import { SharedModule as UrsaSharedModule } from '../../shared/shared.module';
import { CategorizationContainerComponent } from '../categorization/views/categorization-container/categorization-container.component';
import { GenAiContainerComponent } from '../gen-ai/views/gen-ai-container/gen-ai-container.component';
import { H3mlModule } from '../h3ml/h3ml.module';
import { FinalizeButtonComponent } from './finalize-button/finalize-button.component';
import { FinalizeSampleDialogComponent } from './finalize-sample-dialog/finalize-sample-dialog.component';
import { InputSummaryComponent } from './input-summary/input-summary.component';
import { RejectionHistoryComponent } from './rejection-history/rejection-history.component';
import { SampleTaskReviewStatusComponent } from './sampe-task-review-status/sample-task-review-status.component';
import { SamplingControlsComponent } from './sampling-controls/sampling-controls.component';
import { SamplingWorkspaceNavComponent } from './sampling-controls/sampling-workspace-nav.component';
import { SamplingNavControlsComponent } from './sampling-nav-controls/sampling-nav-controls.component';
import { SamplingWorkspaceFooterComponent } from './sampling-workspace-footer/sampling-workspace-footer.component';
import { SamplingWorkspaceHeaderComponent } from './sampling-workspace-header/sampling-workspace-header.component';
import { SamplingWorkspaceHostComponent } from './sampling-workspace-host.component';
import { SamplingWorkspaceNavbarComponent } from './sampling-workspace-navbar/sampling-workspace-navbar.component';
import { SamplingWorkspaceComponent } from './sampling-workspace.component';

@NgModule({
  imports: [
    CommonModule,
    CrossTeamSharedModule,
    FontAwesomeModule,
    FormsModule,
    GenAiContainerComponent,
    CategorizationContainerComponent,
    H3mlModule,
    NasModelModule,
    OverlayModule,
    UrsaSharedModule,
    MatButtonModule,
    MatDialogActions,
    MatDialogClose,
    MatProgressBar,
    SampleTaskReviewStatusComponent,
    ProgressBarComponent,
    SamplingNavControlsComponent,
    FinalizeButtonComponent,
  ],
  declarations: [
    InputSummaryComponent,
    RejectionHistoryComponent,
    SamplingControlsComponent,
    SamplingWorkspaceNavComponent,
    SamplingWorkspaceNavbarComponent,
    SamplingWorkspaceComponent,
    SamplingWorkspaceHostComponent,
    SamplingWorkspaceHeaderComponent,
    SamplingWorkspaceFooterComponent,
    FinalizeSampleDialogComponent,
  ],
  exports: [SamplingWorkspaceHostComponent],
})
export class SamplingWorkspaceModule implements DoBootstrap {
  constructor(private injector: Injector) {}

  ngDoBootstrap() {
    customElements.define(
      'ursa-sampling-workspace',
      createCustomElement(SamplingWorkspaceHostComponent, {
        injector: this.injector,
      }),
    );
  }
}
